import {ConectaProModel} from "./conecta-pro-model";
import {SellerAppModel} from "./seller-app-model";
import {SecurityCodeModel} from "./security-code-model";
import {ChecklistModel} from "./checklist-model";
import {WhatsappModel} from "./whatsapp-model";
import {WhatsappOficialModel} from "./whatsapp-oficial-model";
import {MerchantModel} from "../global";

let conectaProModel = null;
let securityCodeModel = null;
let sellerAppModel = null;
let checklistModel = null;
let whatsappModel = null;
let whatsappOficialModel = null;


export function modelChecklist() {
  if (!checklistModel) checklistModel = new ChecklistModel({
    models: {
      merchant: MerchantModel()
    }
  });
  return checklistModel;
}

export function modelConectaPro() {
  if (!conectaProModel) conectaProModel = new ConectaProModel({
    models: {
      securityCode: modelSecurityCode()
    }
  });
  return conectaProModel;
}
export function modelSellerApp() {
  if (!sellerAppModel) sellerAppModel = new SellerAppModel({
    models: {
      securityCode: modelSecurityCode()
    }
  });
  return sellerAppModel;
}
export function modelSecurityCode() {
  if (!securityCodeModel) securityCodeModel = new SecurityCodeModel();
  return securityCodeModel;
}

export function modelWhatsapp() {
  if (!whatsappModel) whatsappModel = new WhatsappModel();
  return whatsappModel;
}

export function modelWhatsappOficial() {
  if (!whatsappOficialModel) whatsappOficialModel = new WhatsappOficialModel();
  return whatsappOficialModel;
}
